import * as React from "react";

import { LockBlack } from "@livechat/design-system-icons";
import { Button, Icon } from "@livechat/design-system-react-components";

import { EmptyState } from "components/empty-state/EmptyState";
import Flex from "components/layout/Flex";
import { IIntegration } from "store/entities/integrations";

interface IProps {
  shopifyIntegration?: IIntegration;
}

const ShopifySubscription: React.FC<IProps> = ({ shopifyIntegration }) => (
  <Flex alignItems="center" justifyContent="center" height="100%">
    <EmptyState title="Your subscription is handled by Shopify" icon={<Icon source={LockBlack} size="xxxlarge" />}>
      <Button
        kind="link-light"
        href={shopifyIntegration?.settings?.billingUrl}
        target="_blank"
        rel="nofollow noreferrer noopener"
      >
        Visit our dedicated page
      </Button>{" "}
      to manage your HelpDesk subscription.
    </EmptyState>
  </Flex>
);

export default ShopifySubscription;
